// extracted by mini-css-extract-plugin
export default {"dot":"_497e51e0","activeDot":"_9a34ffec"};